import { call, put } from "redux-saga/effects";
import { reviewApi } from "@services/api";
import {
  checkUserReviewActions,
  getCourseReviewsActions,
  getCourseReviewSummaryAction,
  updateReviewCourseActions,
} from "../slices";
import { showFailureToast } from "@helpers";

function* updateReviewCourseWorker({ payload }) {
  yield put(updateReviewCourseActions.pending());
  yield put(checkUserReviewActions.updateUserReview(payload.review));

  try {
    const response = yield call(reviewApi.updateReviewCourse, payload.review);
    yield put(updateReviewCourseActions.success(response));
    yield put(getCourseReviewSummaryAction(payload.courseId));
    yield put(checkUserReviewActions.updatePrevReview(payload.review));
    yield put(getCourseReviewsActions.updateUserReview(payload.review));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(updateReviewCourseActions.failure(error));
    yield call(showFailureToast, "Review was failed!");
    // TODO: handle callback | onFailure
  }
}

export { updateReviewCourseWorker };
